import { CheckSquare, Circle, Home, Phone, Settings, Users } from "lucide-react";
import { SidebarItem } from "./Sidebar";
import { User } from "lucide-react";

export const tenantAdminItems: SidebarItem[] = [
  // Admin dashboard (shown to ADMIN role only)
  {
    id: "admin/dashboard",
    label: "Dashboard",
    icon: Home,
    path: "/admin/dashboard",
  },
  {
    id: "ai-agent",
    label: "AI-Agent",
    icon: Users,
    children: [
      {
        id: "add-ai-agent",
        label: "Add AI-Agent",
        icon: Circle,
        path: "/add-ai-agent",
      },
      {
        id: "manage-ai-agents",
        label: "Manage AI-Agents",
        icon: Circle,
        path: "/ai-agents",
      },
    ],
  },
  {
    id: "auto-dialer",
    label: "History Logs",
    icon: Phone,
    path: "/auto-dialer",
  },

  {
    id: "tasks",
    label: "Appointments",
    icon: CheckSquare,
    children: [
      {
        id: "all-appointments",
        label: "All Appointments",
        icon: Circle,
        path: "/all-appointments",
      },
      {
        id: "task-calendar",
        label: "Appointment Calendar",
        icon: Circle,
        path: "/calendar",
      },
    ],
  },

  {
    id: "settings",
    label: "Settings",
    icon: Settings,
    children: [
      {
        id: "profile",
        label: "Profile",
        icon: User,
        path: "/profile",
      },
    ],
  },
];
